const buildQuery = (query, paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage) =>{
    if(filter){
        filter.forEach(criteria => {
            query = query.where(criteria.attribute, criteria.operation, criteria.value);
        })
    }
    if(searchTerms && searchTerms.length > 0){
        query = query.where('_searchTerms', 'array-contains', searchTerms[0]);
    }
    if(orderBy){
        query = query.orderBy(orderBy[0], orderBy[1]);
    }
    if(paginationAction){
        if(paginationAction == 'next'){
            query = query.startAfter(lastRowRef);
        }else if(paginationAction == 'prev'){
            query = query.endBefore(firstRowRef);
        }else if(paginationAction == 'update'){
            query = query.startAt(firstRowRef);
        }
    }
    
    if(itemsPerPage){
        query = query.limit(itemsPerPage)
    }
    
    return query;
}

export default buildQuery;